import { homepageSeoContent, brandSectionContent } from '@/mocks/seoContent';

export default function BrandSection() {
  const { whatIsTitle, whatIsContent, whyTitle, featureCards, comparisonTitle, comparisonPlatforms } = homepageSeoContent;

  return (
    <>
      <section className="w-full bg-background-50 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 items-start">
            <div className="lg:w-2/5">
              <span className="text-xs font-medium text-accent-600 uppercase tracking-wider whitespace-nowrap">
                {brandSectionContent.label}
              </span>
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mt-3 mb-6">
                {whatIsTitle}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {brandSectionContent.heading}
              </p>
              <div className="flex items-center gap-3 mt-6">
                <div className="flex -space-x-2">
                  <div className="w-8 h-8 rounded-full bg-secondary-300 border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20woman%20with%20curly%20brown%20hair%20wearing%20a%20cream%20blouse%2C%20smiling%20warmly%20at%20camera%2C%20soft%20studio%20lighting%20on%20a%20pale%20sage%20green%20background%2C%20genuine%20friendly%20expression%2C%20clean%20corporate%20headshot%20style%2C%20no%20text&width=64&height=64&seq=avatar-1-v2&orientation=squarish" alt="Community member" className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="w-8 h-8 rounded-full bg-secondary-300 border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20in%20his%20thirties%20with%20short%20dark%20hair%20and%20a%20neat%20beard%2C%20wearing%20a%20light%20blue%20button%20down%20shirt%2C%20confident%20warm%20smile%2C%20soft%20studio%20lighting%20on%20a%20warm%20grey%20background%2C%20approachable%20executive%20portrait%20style%2C%20no%20text&width=64&height=64&seq=avatar-2-v2&orientation=squarish" alt="Community member" className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="w-8 h-8 rounded-full bg-secondary-300 border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20asian%20woman%20with%20shoulder%20length%20black%20hair%20wearing%20a%20soft%20pink%20top%2C%20gentle%20smile%20with%20eyes%20slightly%20crinkled%2C%20bright%20studio%20lighting%20on%20a%20pale%20ivory%20background%2C%20friendly%20trustworthy%20headshot%2C%20no%20text&width=64&height=64&seq=avatar-3-v2&orientation=squarish" alt="Community member" className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="w-8 h-8 rounded-full bg-secondary-300 border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20with%20silver%20grey%20hair%20and%20a%20warm%20genuine%20smile%2C%20wearing%20a%20navy%20polo%20shirt%2C%20soft%20natural%20lighting%20on%20a%20warm%20sand%20background%2C%20wise%20friendly%20grandfatherly%20headshot%2C%20no%20text&width=64&height=64&seq=avatar-4-v2&orientation=squarish" alt="Community member" className="w-full h-full object-cover" loading="lazy" />
                  </div>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">
                  {brandSectionContent.communityText}
                </span>
              </div>
            </div>

            <div className="lg:w-3/5">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {whatIsContent}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 text-center mb-4">
            {whyTitle}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mt-10">
            {featureCards.map((card) => (
              <div key={card.title} className="bg-background-50 rounded-2xl p-6 md:p-7 hover:-translate-y-1 transition-all duration-300">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${card.icon} text-xl text-accent-600`}></i>
                </div>
                <h3 className="text-base font-heading text-foreground-950 mb-2 whitespace-nowrap">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 text-center mb-4">
            {comparisonTitle}
          </h2>
          <p className="text-sm text-foreground-600 text-center max-w-xl mx-auto mb-10">
            See how Kakobuy Spreadsheet stacks up against other platforms in the spreadsheet shopping ecosystem.
          </p>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] border-collapse">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Platform</th>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Spreadsheet Quality</th>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Product Database</th>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">User Experience</th>
                </tr>
              </thead>
              <tbody>
                {comparisonPlatforms.map((platform) => (
                  <tr
                    key={platform.name}
                    className={`border-b border-background-200/60 ${
                      platform.highlight ? 'bg-primary-50/30' : ''
                    }`}
                  >
                    <td className="py-3.5 px-4">
                      <span className={`text-sm font-medium whitespace-nowrap ${
                        platform.highlight ? 'text-primary-700' : 'text-foreground-800'
                      }`}>
                        {platform.highlight && <i className="ri-star-fill text-xs mr-1.5 text-accent-500"></i>}
                        {platform.name}
                      </span>
                    </td>
                    <td className="py-3.5 px-4">
                      <span className="text-sm text-foreground-600 whitespace-nowrap">{platform.quality}</span>
                    </td>
                    <td className="py-3.5 px-4">
                      <span className="text-sm text-foreground-600 whitespace-nowrap">{platform.database}</span>
                    </td>
                    <td className="py-3.5 px-4">
                      <span className="text-sm text-foreground-600 whitespace-nowrap">{platform.experience}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}